import { Search } from "lucide-react";
import React, { useState } from "react";
import { Input } from "src/components/ui/input";

const PanelHeader: React.FC = () => {
  const [searchValue, setSearchValue] = useState('');

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  return (
    <div className="flex flex-row flex-wrap md:flex-row sm:justify-between items-center gap-5">
      <div className="relative flex-1 md:order-first max-w-96">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
        <Input
          type="text"
          placeholder="Search"
          value={searchValue}
          onChange={handleSearchChange}
          className="pl-10 bg-white rounded-full placeholder:text-black/75 h-10 border-none shadow-none focus:outline-none focus:ring-0 focus:border-gray-300 focus-visible:outline-none focus:ring-0 focus:ring-transparent"
        />
      </div>
    </div>
  );
};

export default PanelHeader;
